export function filtro(
  cadastros,
  equipe,
  microArea,
  exibirVermelhos,
  exibirVerdes
) {
  let cadastros_filtrados = cadastros

  if (equipe !== '') {
    cadastros_filtrados = cadastros_filtrados.filter(
      (item) => item.nu_ine == equipe.ine_esf_eap
    )
  }

  if (microArea !== '') {
    cadastros_filtrados = cadastros_filtrados.filter(
      (item) => item.micro_area == microArea
    )
  }

  if (exibirVermelhos === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      if (item.inseguranca_alimentar == 'Moderada ou grave') {
        return true
      }
    })
  }

  if (exibirVerdes === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      if (item.inseguranca_alimentar == 'Leve') {
        return true
      }
    })
  }

  return cadastros_filtrados
}
